export default __webpack_public_path__ + "static/media/aromal.e939b85c.svg";